"use client"

import type { LucideIcon } from "lucide-react"

/**
 * A round icon action in a phone page's top bar, beside the back button and in the same style. Use it when a
 * page has one or two actions: they stay one tap away instead of hiding behind ⋯ (which is for three or more,
 * or for a destructive action that needs its label).
 */
export function MobileHeaderIconButton({
  icon: Icon,
  label,
  onClick,
  disabled = false,
  loading = false,
}: {
  icon: LucideIcon
  /** Read by screen readers and shown as the tooltip; the button itself shows only the icon. */
  label: string
  onClick: () => void
  disabled?: boolean
  loading?: boolean
}) {
  return (
    <button
      type='button'
      onClick={onClick}
      disabled={disabled || loading}
      aria-label={label}
      title={label}
      className='inline-flex size-11 shrink-0 items-center justify-center rounded-full bg-card text-foreground shadow-sm ring-1 ring-border/70 active:bg-muted disabled:opacity-45'
    >
      {loading ? (
        <span aria-hidden className='size-4 animate-spin rounded-full border-2 border-current border-t-transparent' />
      ) : (
        <Icon aria-hidden className='size-[1.125rem]' />
      )}
    </button>
  )
}
